import { SDUIImage } from "@faire/deprecated-retailer-visitor-shared/components/SDUI/__internal__/Image/SDUIImage";
import { IImage } from "@faire/web-api--source/indigofair/data/IImage";
import { IResponsiveImages } from "@faire/web-api--source/indigofair/data/IResponsiveImages";
import { cn } from "@faire/web/tools/cn";

type Position = "top-left" | "top-right" | "bottom-left" | "bottom-right";

interface DecorativeImageProps {
  index: number;
  responsiveImage: IResponsiveImages | undefined;
  position: Position;
}

const getPositionClass = (position: Position) => {
  switch (position) {
    case "top-left":
      return "top-0 left-0";
    case "top-right":
      return "top-0 right-0";
    case "bottom-left":
      return "bottom-0 left-0";
    case "bottom-right":
      return "bottom-0 right-0";
  }
};

export const DecorativeImage: React.FC<DecorativeImageProps> = ({
  index,
  responsiveImage,
  position,
}) => {
  const mobileImageWidth = responsiveImage?.mobile_and_above?.[index]?.width;
  const tabletImageWidth = responsiveImage?.tablet_and_above?.[index]?.width;
  const desktopImageWidth = responsiveImage?.desktop_and_above?.[index]?.width;

  const mobileImage =
    responsiveImage?.mobile_and_above?.[index] ?? IImage.build();
  const tabletImage =
    responsiveImage?.tablet_and_above?.[index] ?? IImage.build();
  const desktopImage =
    responsiveImage?.desktop_and_above?.[index] ?? IImage.build();

  return (
    <SDUIImage
      // In this case, we are forcing backend to send the image width to the client.
      // If BE is not providing one, we will not render any image.
      responsiveImage={{
        mobileAndAbove: mobileImageWidth ? mobileImage : IImage.build(),
        tabletAndAbove: tabletImageWidth ? tabletImage : IImage.build(),
        desktopAndAbove: desktopImageWidth ? desktopImage : IImage.build(),
      }}
      optimizeImageOptions={{
        mobileAndAbove: { width: mobileImageWidth },
        tabletAndAbove: { width: tabletImageWidth },
        desktopAndAbove: { width: desktopImageWidth },
      }}
      className={cn("absolute z-0", getPositionClass(position))}
    />
  );
};
